import { HttpClient } from "@angular/common/http";
import { Injector } from "@angular/core";
import { WorkplaceBase } from "../../workplace-base/workplace-base";
import { AppServiceHelperService } from "../../../../services/app-service-helper.service";
import { EventBusService } from "../../../../services/event-bus.service";

/**
 * Workplace action handler. Use this class to listen to events and perform an action.
 * Register them in the workplace by returning them inside the actionHandlers getter
 */
export abstract class WorkplaceActionHandlerBase {
  /**
   * The EventBusService
   */
  protected eventBus: EventBusService;

  /**
  * The Angular HttpClient
  */
  protected http: HttpClient;

  /**
   * The AppServiceHelperService
   */
  protected appServiceHelper: AppServiceHelperService;

  /**
   * Constructor
   * @param injector Ihe Angular injector
   * @param workplace The workplace in which the action should be performed
   * @param topic Topic (subscribeEvent topic)
   */
  constructor(protected injector: Injector, protected workplace: WorkplaceBase, public topic: string) {
    this.eventBus = this.injector.get(EventBusService);
    this.http = this.injector.get(HttpClient);
    this.appServiceHelper = this.injector.get(AppServiceHelperService);
  }

  /**
   * Handles an event
   * @param payload The (untyped) payload. Can also be a callback function
   */
  public abstract handle(payload: any): void;
}
